module.exports = __webpack_public_path__ + "img/cns_android20.66792cbd.png";